import { formatNumber } from '../../../core/formatter/formatNumber';
import * as React from 'react';

interface CustomToolProps extends React.ClassAttributes<any> {
    data: any;
    dataKeys: string[];
    labelPrefix?: string;
    labelSuffix?: string;
    legendTitle: any[];
    unit?: string[];
    source?: string;
    fontSize?: string;
}

export class CustomTool extends React.Component<CustomToolProps, {}> {

    constructor(props: any) {
        super(props);
    }

    render() {
        let { dataKeys, legendTitle, unit, source, fontSize } = this.props;
        const { active, payload, label } = this.props.data;

        const labelPrefix: string = typeof this.props.labelPrefix === 'string' ? this.props.labelPrefix : null;
        const labelSuffix: string = typeof this.props.labelSuffix === 'string' ? this.props.labelSuffix : null;
        dataKeys = dataKeys || [];
        legendTitle = legendTitle || [];
        unit = unit || [];

        if (active) {
            const ttStyle: any = {
                padding: '2px 4px', margin: 0, whiteSpace: 'nowrap', display: 'flex', flexDirection: 'row', alignItems: 'baseline', fontSize: fontSize || '0.9em'
            };

            const toolTipp: any[] = [];

            if (source === 'payload') {

            } else {
                if (label) {
                    toolTipp.push(<div style={{ ...ttStyle, fontWeight: 'bold' }} key='tooltip_label'>{labelPrefix}{label}{labelSuffix}</div>);
                }
            }

            if (Array.isArray(payload)) {
                payload.forEach((element: any, idx: number) => {
                    if (source === 'standard') {
                        const colors = element.payload.yKeyColors || [];
                        const bColor = element.color || colors[idx];
                        const dIndex = dataKeys.indexOf(element.dataKey);
                        toolTipp.push(
                            <div style={ttStyle} key={`tooltip_${idx}`}>
                                <div style={{ width: 10, height: 10, backgroundColor: bColor, marginRight: 5 }} />
                                <div>
                                    <strong>{`${legendTitle[dIndex] || element.dataKey}:`}</strong> {`${formatNumber(element.value)} ${unit[dIndex] || ''}`}
                                </div>
                            </div>
                        );
                    } else if (source === 'payload') {
                        const dKey = element.dataKey;
                        const dRow = element.payload;
                        // console.log(dKey, dRow);
                        const dataRow = dRow.extraValues && dRow.extraValues[dKey] ? dRow.extraValues[dKey] : dRow;
                        toolTipp.push(
                            <div style={ttStyle} key={`tooltip_${idx}`}>
                                <div style={{ width: 10, height: 10, backgroundColor: dataRow.color, marginRight: 5 }} />
                                <div>
                                    <strong>{(dataRow.key || '') + ' ' + (dataRow.name || '')}:</strong> {`${formatNumber(dataRow.value)} ${dataRow.unit || ''}`}
                                </div>
                            </div>
                        );
                    } else {
                        const bColor = element.color || (element.payload ? element.payload.fill : null);
                        const dIndex = dataKeys.indexOf(element.dataKey);
                        toolTipp.push(
                            <div style={ttStyle} key={`tooltip_${idx}`}>
                                <div style={{ width: 10, height: 10, backgroundColor: bColor, marginRight: 5 }} />
                                <div>
                                    <strong>{`${legendTitle[dIndex] || element.dataKey}:`}</strong> {`${formatNumber(element.value)} ${unit[dIndex] || ''}`}
                                </div>
                            </div>
                        );
                    }
                });
            }
            return toolTipp;
        }

        return null;
    }
}
